import { SET_USERROLE_START,
  SET_USERROLE_COMPLETED,
  SET_USERROLE_SUCCESS} from '../actions/actiontypes'

const INIT_STATE = {
	success : false
}

export default function(state = INIT_STATE, action) {
	switch(action.type){
		case SET_USERROLE_START:{
			return state;
		}
		case SET_USERROLE_SUCCESS:{
			return {...state, success : true };
		}
		default: {
			return state;
		}
	}
}
